"use client";

import Carousel from "react-multi-carousel";
import { TESTIMONIALS_DATA } from "../../../data/testimonals";

export const Testimonials = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1497 },
      items: 1,
      slidesToSlide: 1,
    },
    semitablet: {
      breakpoint: { max: 1496, min: 1081 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1080, min: 721 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 720, min: 481 },
      items: 1,
      slidesToSlide: 1,
    },
    mobileSmall: {
      breakpoint: { max: 480, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <div className="sliders  pos-rel">
      <Carousel
        swipeable
        draggable={false}
        // arrows={true}
        showDots={false}
        responsive={responsive}
        renderDotsOutside
        ssr={true}
        infinite={true}
        removeArrowOnDeviceType={[]}
        autoPlay={true}
        autoPlaySpeed={6000}
        partialVisible={true}
      >
        {/* {TESTIMONIALS_DATA.map((i) => (
          <div className="slider-one  " key={i}>
            <div className="row col-1-1 flex center-left">
              <p className="color-white italic p-18 l-h-1-5 font-mont f-w-400 d">{`" ${i.content}"`}</p>

              <div className=" flex" style={{ gap: "8px" }}>
                <div
                  className="icon b-r-100 cover-img"
                  style={{
                    backgroundImage: `url(${i.image})`,
                  }}
                ></div>
                <div
                  className=" flex left-center "
                  style={{ flexDirection: "column" }}
                >
                  <h6 className="f-w-700 t-t-u p-18 t t font-barlow color-white">
                    {i.name}
                  </h6>
                  <p className="f-w-300 font-nunito-sans date color-white t-t-u">
                    {i.role}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))} */}

        {TESTIMONIALS_DATA.map((item, idx) => (
          <div className="slider-one" key={idx}>
            <div className="testimonial-slide">
              {/* Avatar + name + role */}
              <div className="testimonial-header">
                <div className="avatar" style={{ backgroundImage: `url(${item.image})` }} role="img" aria-label={item.name} />
              </div>

              {/* Quote */}
              <div className="testimonial-body">
                {/* <p className="quote">{"“ " + item.content + " ”"}</p> */}
                <h6 className="testimonial-name">{item.name}</h6>
                <p className="testimonial-role">{item.role}</p>

                <p className="font-montserrat color-white italic p-20 l-h-1-5 font-mont f-w-400">{`" ${item.content}"`}</p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};
